import React, { useState, type FC } from 'react';

import type { DispatcherDispatchRecord } from './dispatcher_types';
import { DispatcherVehicleRequestDialog } from './dispatcher_vehicle_request_dialog';

export const DispatcherVehicleRequestButton: FC<{
  dispatch: DispatcherDispatchRecord;
  onSave(): void;
}> = ({ dispatch, onSave }) => {
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <a
        className="btn-link text-bold"
        href="#"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();

          onOpen();
        }}
      >
        {dispatch.vehicle_preferences?.length || dispatch.vehicle_recipe ? 'Edit Vehicles' : 'Add Vehicles'}
      </a>
      {open && (
        <DispatcherVehicleRequestDialog
          dispatch={dispatch}
          onClose={() => {
            onClose();
          }}
          onSave={() => {
            onSave();
            onClose();
          }}
        />
      )}
    </>
  );
};
